import { Injectable } from '@angular/core';
import { Util } from '@libs/utilities/util';

import { INgTagInputModeConfig } from './tag-input.data';
import { EnumNgAlignment, EnumNgCasingType, EnumNgSuggestionMode, EnumNgSuggestionType, EnumNgTagInputEditModes, INgTagInputConfig } from './tag-input.interface';


@Injectable({
	providedIn: 'root'
})
export class NgTagInputModel {

	//** Configurations */
	private readonly MAX_HINT_TEXT_LENGTH: number = 20;

	//** Data of the User Interface */
	private uiData: INgTagInputModel = this.getInitialObject();

	/**------------------------------------------------------
	 * Get Data
	 */
	get data(): INgTagInputModel 	   { return this.uiData; }
	set data(data: INgTagInputModel) { this.uiData = data; }


	/**------------------------------------------------------
	 * Helper Function
 	 */
	private getInitialObject(): INgTagInputModel {

		// Default tag input model data
		const newObject: INgTagInputModel = {
			mode				: null!,
			config				: null!,
			tagControl			: {
				selectedItems	: [],
				activeTag		: null!,
				focusedElemIndex: 0
			},
			suggestions 		: {
				isActive		: false,
				markedItem		: null!
			},
			dragPlaceholder 	: {
				height			: 0,
				width			: 0
			}
		};
		return newObject;
	}


	/**------------------------------------------------------
	 * Check Configurations
	 */
	updateConfig(inputConfig: Partial<INgTagInputConfig>): void {

		//0 - define default config
		const config: INgTagInputConfig = {
			editMode		: EnumNgTagInputEditModes.TagInput,
			duplication	   	: false,
			casingType 		: EnumNgCasingType.LowerCase,
			hintText	   	: '+ Add',
			minTags			: 0,
			height			: null!,
			inputClass		: null!,
			maxTags			: Number.MAX_SAFE_INTEGER,
			maxTagLength	: Number.MAX_SAFE_INTEGER,
			suggestion		: {
				type: EnumNgSuggestionType.Inline,
				mode: EnumNgSuggestionMode.Auto
			},
			alignment		: EnumNgAlignment.Left
		};

		//1 - assign the provided config from input
		if (Util.Basic.isDefined(inputConfig)) Util.Basic.deepAssignPartial(config, inputConfig);
		this.data.config = config;

		//2 - validate the configurations of the tag input
		this.checkValidation(this.data.config);
	}

	//** Tag validation */
	private checkValidation(config: Partial<INgTagInputConfig>) {
		if (Util.String.isNotEmpty(config.hintText) && config.hintText!.length > this.MAX_HINT_TEXT_LENGTH) throw new Error(`NgTagInputComponent UIModel => checkValidation => FATAL ERROR: Placeholder length must be less than ${this.MAX_HINT_TEXT_LENGTH}`);
		if (!Util.Number.isInteger(config.minTags!) || !Util.Number.isInteger(config.maxTags!)) throw new Error(`NgTagInputComponent UIModel => checkValidation => FATAL ERROR: min Tags length and and max Tags length must be and integer`);
		if (config.maxTags! > 0 && config.minTags! > config.maxTags!) throw new Error(`NgTagInputComponent UIModel => checkValidation => FATAL ERROR: Max tag always be greater that 0 and min tag`);
	}
}


//** Interfaces --------------------------------- */
export interface INgTagInputModel {
	mode			: INgTagInputModeConfig;
	config			: INgTagInputConfig;
	tagControl		: {
		selectedItems	: string[];
		activeTag		: number;
		focusedElemIndex: number;
	};
	suggestions 	: {
		isActive		: boolean;
		markedItem		: number;
	};
	dragPlaceholder : {
		height			: number;
		width			: number;
	};
}
